import {
  Button,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Grid,
  Typography,
} from "@material-ui/core";

import { Alert } from "@material-ui/lab";
import CustomDialog from "../../components/CustomDialog";
import { Field } from "formik";
import { TextField as FormikTextField } from "formik-material-ui";
import useLocale from "../../../hooks/useLocale";
import GovGrButton from "../../../components/GovGrButton";

const PostponeModal = (props) => {
  const { open, message, submitAccept, submitReject } = props;
  const { t } = useLocale();

  return (
    <CustomDialog open={open} maxWidth="md">
      <DialogTitle id="form-dialog-title">
        {t("Postpone appointment")}
      </DialogTitle>
      <DialogContent>
        <DialogContentText>
          <Alert severity="info">{t(message)}</Alert>
          <Field
            variant="outlined"
            name="comments"
            margin="normal"
            multiline
            fullWidth
            rows={5}
            component={FormikTextField}
            label={t("Comments")}
          />
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Grid container justifyContent="space-between">
          <Grid item>
            <GovGrButton
              onClick={submitReject}
              color="primary"
              style={{ color: "red" }}
              buttonText={t("Postpone")}
            />
          </Grid>
          <Grid item>
            <Button
              onClick={submitAccept}
              type="submit"
              variant="contained"
              color="primary"
              buttonText={t("Close")}
            />
          </Grid>
        </Grid>
      </DialogActions>
    </CustomDialog>
  );
};

export default PostponeModal;
